import Breadcrumb from 'react-bootstrap/Breadcrumb';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { URL_PATH } from '../control-plane/constants';

/** Breadcrumb for AI Service (not in ccs-ui-components BreadcrumbComponent map). */
const AiServiceBreadcrumb = () => {
  const { t: translate } = useTranslation();

  return (
    <Breadcrumb data-testid="breadcrumb" className="bread-crumb">
      <Breadcrumb.Item
        linkAs={Link}
        linkProps={{ to: URL_PATH.DASHBOARD }}
        className="bread-crumb-items"
      >
        {translate('common_breadcrumn.txt_control_plane')}
      </Breadcrumb.Item>
      <Breadcrumb.Item
        linkAs={Link}
        linkProps={{ to: URL_PATH.SERVICE_HOME }}
        className="bread-crumb-items"
      >
        {translate('common_breadcrumn.txt_services')}
      </Breadcrumb.Item>
      <Breadcrumb.Item active className="bread-crumb-items">
        {translate('common_breadcrumn.txt_ai_service')}
      </Breadcrumb.Item>
    </Breadcrumb>
  );
};

export default AiServiceBreadcrumb;
